// @ts-nocheck
import React , {useState} from "react";
import {RUTA_API_ALIAS, RUTA_API_AREAS, RUTA_API_USUARIOS, URL_API_SIA} from "../../../Contantes/Constantes";
import {useBody} from "../../../Body/state/BodyContext";
import axios from "axios";
import {setupInterceptorsTo} from "../../../Componentes/API/AxiosBuilder";
import { FormularioContext } from "./FormularioContext";
import {useUsuarios} from "../UsuarioContext";
import {EXTENSION_MAIL_INSTITUCIONAL} from "../../../Contantes/Constantes";

export function ProvideFormulario({ children }) {
    const emails = useProvideFormulario();
    return (
        <FormularioContext.Provider value={emails}>
            {children}
        </FormularioContext.Provider>
    );
}

function useProvideFormulario() {
    const {setMessage} = useBody();
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const [provincias, setProvincias] = useState([]);
    const [paises, setPaises] = useState([]);
    const [sexos,setSexos] = React.useState([]);
    const [filiaciones,setFiliaciones] = React.useState([]);
    const [sedes,setSedes] = React.useState([]);
    const [estadosCiviles,setEstadosCiviles] = React.useState([]);
    const [fechaNacimiento,setFechaNacimiento] = React.useState(null);
    const [errores,setErrores] = React.useState({
        apellido: false,
        nombre: false,
        uid: false,
        frbaEmail: false,
        SexoId: false,
        EstadoCivilId: false,
        SedeId: false,
        Direccion: false,
        FiliacionId: false,
        fechaNacimiento: false,
        codigoPostal: false,
        telefonoDomiciliario: false,
        telefonoCelular: false,
        personalEmail: false,
        legajoAlumno: false,
        legajoPersonaUTN: false,
        nacionalidad: false,
        DocumentoDeIdentificacion: false,
        password: false,
        repeat_password: false,
        calle: false,
        altura: false,
        ciudad: false,
        provincia: false,
    });
    const [tiposDocumentoDeIdentificacion, setTiposDocumentoDeIdentificacion] = React.useState([]);
    const [value, setValue]= React.useState({
        nombre: '',
        apellido: '',
        uid: '',
        frbaEmail: EXTENSION_MAIL_INSTITUCIONAL,
        fechaNacimiento: null,
        SexoId: 0,
        EstadoCivilId: 0,
        SedeId: 0,
        password: '',
        repeat_password: '',
        Direccion: {
            calle: '',
            altura: '',
            ciudad: '',
            provincia: 0,
            codigoPostal: '',
        },
        filiaciones: [],
        telefonoDomiciliario: null,
        telefonoCelular: null,
        personalEmail: '',
        legajoAlumno: '',
        legajoPersonaUTN: '',
        nacionalidad: 0,
        DocumentoDeIdentificacion: {
            numero : '',
            TipoDocumentoDeIdentificacionId : 0
        }
    });

    const resetearForm = () => {
        setValue({
            nombre: '',
            apellido: '',
            uid: '',
            frbaEmail: EXTENSION_MAIL_INSTITUCIONAL,
            fechaNacimiento: null,
            SexoId: 0,
            password: '',
            repeat_password: '',
            Direccion: {
                calle: '',
                altura: '',
                ciudad: '',
                provincia: 0,
                codigoPostal: '',
            },
            FiliacionId: 0,
            SedeId: 0,
            telefonoDomiciliario: null,
            telefonoCelular: null,
            personalEmail: '',
            legajoAlumno: '',
            legajoPersonaUTN: '',
            nacionalidad: 0,
            DocumentoDeIdentificacion: {
                numero : '',
                TipoDocumentoDeIdentificacionId : 0
            }
        })
        resetearErrores();
        setLoading(false);
    }
    const resetearErrores = () => {
        setErrores({
            apellido: false,
            nombre: false,
            uid: false,
            frbaEmail: false,
            SexoId: false,
            SedeId: false,
            Direccion: false,
            FiliacionId: false,
            fechaNacimiento: false,
            codigoPostal: false,
            telefonoDomiciliario: false,
            telefonoCelular: false,
            personalEmail: false,
            legajoAlumno: false,
            legajoPersonaUTN: false,
            nacionalidad: false,
            DocumentoDeIdentificacion: false,
            password: false,
            repeat_password: false,
            calle: false,
            altura: false,
            ciudad: false,
            provincia: false,
        })
    }




    return {
        usuarios , setUsuarios , provincias, paises, loading, setLoading,setSexos,setFiliaciones,setSedes,setFechaNacimiento,setErrores,setValue,setTiposDocumentoDeIdentificacion, setEstadosCiviles,
        sexos,filiaciones,sedes,fechaNacimiento,errores,tiposDocumentoDeIdentificacion, estadosCiviles, value , resetearErrores, resetearForm
    };
}
